import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import Breadcrumb from "../elements/common/Breadcrumb";
import ScrollToTop from "react-scroll-up";
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";

import about from "../assets/images/logo/logotest.png";
import findingImg from "../assets/images/about/finding-us-01.png";
import FooterTwo from "../component/footer/FooterTwo";

class About extends Component {
  render() {
    let title = "About",
      description =
        "At Grand Maple Properties, we believe homes are more than spaces — they’re stories waiting to unfold. Nestled in the heart of Fethiye, our agency was founded on a simple idea: to redefine what it means to buy and sell property by bringing warmth, trust, and artistry back into real estate. We don’t just list homes; we curate them. Every villa, every view, every hidden gem we represent has been handpicked for its character, craftsmanship, and connection to the landscape. Whether it’s a hillside retreat bathed in Mediterranean light or a modern sanctuary by the sea, our portfolio reflects a life well-lived. Our team is deeply rooted in the region — we know its rhythms, its secrets, its soul. That local insight allows us to match clients not only with properties but with places that truly belong to them. With discretion, care, and an unwavering eye for quality, we guide each client through an experience that feels personal from the first call to the final key handover. For us, real estate isn’t about transactions — it’s about transformation. Let’s find the place where your next chapter begins.";
    return (
      <React.Fragment>
        <PageHelmet pageTitle="About" />

        <Header
          headertransparent="header--transparent"
          colorblack="color--black"
          logoname="logo.png"
        />
        {/* Start Breadcrump Area */}
        <Breadcrumb title="About" bgImage="/assets/images/house/aboutbg.jpeg" />
        {/* End Breadcrump Area */}

        {/* Start About Area  */}
        <div className="rn-about-area ptb--120 bg_color--1">
          <div className="rn-about-wrapper">
            <div className="container">
              <div className="row row--35 align-items-center">
                <div className="col-lg-5">
                  <div className="thumbnail">
                    <img className="w-100" src={about} alt="About Images" />
                  </div>
                </div>
                <div className="col-lg-7">
                  <div className="about-inner inner">
                    <div className="section-title">
                      <h2 className="title">{title}</h2>
                      <p className="description">
                        At Grand Maple Properties, we believe homes are more
                        than spaces — they’re stories waiting to unfold. Nestled
                        in the heart of Fethiye, our agency was founded on a
                        simple idea: to redefine what it means to buy and sell
                        property by bringing warmth, trust, and artistry back
                        into real estate.
                      </p>
                      <p className="description">
                        We don’t just list homes; we curate them. Every villa,
                        every view, every hidden gem we represent has been
                        handpicked for its character, craftsmanship, and
                        connection to the landscape. Whether it’s a hillside
                        retreat bathed in Mediterranean light or a modern
                        sanctuary by the sea, our portfolio reflects a life
                        well-lived.
                      </p>
                      <p className="description">
                        Our team is deeply rooted in the region — we know its
                        rhythms, its secrets, its soul. That local insight
                        allows us to match clients not only with properties but
                        with places that truly belong to them. With discretion,
                        care, and an unwavering eye for quality, we guide each
                        client through an experience that feels personal from
                        the first call to the final key handover.
                      </p>
                    </div>
                    <div className="row mt--30">
                      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="about-us-list">
                          <h5 className="title">
                            For us, real estate isn’t about transactions — it’s
                            about transformation.
                          </h5>
                        </div>
                        <div className="about-us-list">
                          <h5 className="title">
                            Let’s find the place where your next chapter begins.
                          </h5>
                          <p></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End About Area  */}

        {/* Start Back To Top */}
        <div className="backto-top">
          <ScrollToTop showUnder={160}>
            <FiChevronUp />
          </ScrollToTop>
        </div>
        {/* End Back To Top */}

        <FooterTwo />
      </React.Fragment>
    );
  }
}
export default About;
